<template>
  <div class="addEmployeeAvailibilityVue">
      <!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->
    <div class="c-responsive-fixwidth">
              <div class="clearfix o-skillset-area">
                  <div class="employer-info">
                      <div class="field-group">
                          <div class="row">
                              <div class="col-sm-12">
                                  <div class="c-common-space c-common-box-shadow c-radius3">
                                      <div class="c-user-tab-content clearfix o-skillset-area">
                                          <h2 class="h2">Recurring Unavailability:</h2>
                                          <p class="h5-v2 h5-v2-overwrite">Enter the start and end times of unavailable periods separated by a hyphen <strong class="red-mark">(ex: 13:00-18:30).</strong> For multiple periods within a single day, separate periods with a comma <strong class="red-mark">(ex: 13:00-18:30,20:30-22:30)</strong></p>
                                              <div class="row">
                                                  <div class="col-sm-3 table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Sunday</label>
                                                          <input autocomplete="off"@change="onUpdateInputField" v-model="weeklyVacation.sun" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3 table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Monday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.mon" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3 table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Tuesday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.tue" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Wednesday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.wed" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3 table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Thursday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.thu" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3  table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Friday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.fri" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                                  <div class="col-sm-3  table-td-border-right">
                                                      <div class="form-group ">
                                                          <label class="common-label-text">Saturday</label>
                                                          <input autocomplete="off"v-model="weeklyVacation.sat" @change="onUpdateInputField" type="tel" class="form-control" placeholder="Enter Unavailability">
                                                      </div>
                                                  </div>
                                              </div>
                                      </div>
                                  </div>

                                   <!-- <div class="col-sm-12 o-no-padding">

                                      <div class="col-sm-6 o-right-padding-only">
                                          <div class="c-common-space c-responsive-fixwidth c-common-box-shadow c-radius3">
                                              <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxAppend" style="height: 389px;">
                                                  <div class="col-md-12">
                                                      <h2 class="h2">Request time off:</h2>
                                                  </div>
                                                  <div class="col-sm-12 o-no-padding o-running-strip">
                                                      <div class="col-sm-6">
                                                          <div class="form-group ">
                                                              <label class="employee-label-text">Start Date:</label>
                                                              <label class="employee-label-input">
                                                                  <input autocomplete="off"type="text" class="form-control" placeholder="01:59 AM">
                                                              </label>
                                                          </div>
                                                      </div>
                                                      <div class="col-sm-6">
                                                          <div class="form-group ">
                                                              <label class="employee-label-text">Start Time:</label>
                                                              <label class="employee-label-input">
                                                                  <input autocomplete="off"type="text" class="form-control" placeholder="01:59 AM">
                                                              </label>
                                                          </div>
                                                      </div>
                                                      <div class="col-sm-6">
                                                          <div class="form-group ">
                                                              <label class="employee-label-text">End Date:</label>
                                                              <label class="employee-label-input">
                                                                  <input autocomplete="off"type="text" class="form-control" placeholder="01:59 AM">
                                                              </label>
                                                          </div>
                                                      </div>
                                                      <div class="col-sm-6">
                                                          <div class="form-group ">
                                                              <label class="employee-label-text">End Time:</label>
                                                              <label class="employee-label-input">
                                                                  <input autocomplete="off"type="text" class="form-control" placeholder="01:59 AM">
                                                              </label>
                                                          </div>
                                                      </div>
                                                  </div>

                                                  <div class="col-md-12">
                                                      <div class="o-employe-view">
                                                          <a href="#" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Vacation</a>
                                                      </div>
                                                  </div>


                                              </div>
                                          </div>
                                      </div>
                                  </div>  -->


                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        bus
    } from '../../main';
    export default {
        props: {
            weeklyVacationData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                weeklyVacation: {
                    sun: '',
                    mon: '',
                    tue: '',
                    wed: '',
                    thu: '',
                    fri: '',
                    sat: '',
                }
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                bus.$emit('onUpdateVacation', this.weeklyVacation);
                //console.log(this.weeklyVacation)
            }
        },
        created() {
            this.weeklyVacation = this.weeklyVacationData;
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/employees/addEmployeeAvailability.vue